import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\Editor\DuplicateDocumentAsV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/DuplicateDocumentAsV3Controller.php
* @route '/api/editor/{type}/{document}/duplicate-as-v3'
*/
const DuplicateDocumentAsV3Controller = (args: { type: string | number, document: string | number | { id: string | number } } | [type: string | number, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateDocumentAsV3Controller.url(args, options),
    method: 'post',
})

DuplicateDocumentAsV3Controller.definition = {
    methods: ["post"],
    url: '/api/editor/{type}/{document}/duplicate-as-v3',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\Editor\DuplicateDocumentAsV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/DuplicateDocumentAsV3Controller.php
* @route '/api/editor/{type}/{document}/duplicate-as-v3'
*/
DuplicateDocumentAsV3Controller.url = (args: { type: string | number, document: string | number | { id: string | number } } | [type: string | number, document: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return DuplicateDocumentAsV3Controller.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\Editor\DuplicateDocumentAsV3Controller::__invoke
* @see app/Http/Controllers/Document/Editor/DuplicateDocumentAsV3Controller.php
* @route '/api/editor/{type}/{document}/duplicate-as-v3'
*/
DuplicateDocumentAsV3Controller.post = (args: { type: string | number, document: string | number | { id: string | number } } | [type: string | number, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateDocumentAsV3Controller.url(args, options),
    method: 'post',
})

export default DuplicateDocumentAsV3Controller